import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { getAnalyticsSafe } from '@/firebase';

export const platform = 'web';

// Initialize analytics identity for Admin app: sets user_id and non-PII user properties
export async function initAdminAnalyticsIdentity(adminId?: string | number, properties?: Record<string, string | number | boolean | null | undefined>) {
  try {
    const analytics = await getAnalyticsSafe();
    if (!analytics) return;

    if (adminId !== undefined && adminId !== null) {
      setUserId(analytics, String(adminId));
    }

    // Only string values are supported in GA4 user properties
    const cleaned: Record<string, string> = { app_role: 'admin', platform };
    if (properties) {
      Object.keys(properties).forEach((k) => {
        const v = (properties as any)[k];
        if (v !== undefined && v !== null) cleaned[k] = String(v);
      });
    }
    setUserProperties(analytics, cleaned as any);
  } catch {
    // no-op
  }
}

export async function logEventSafe(eventName: string, params?: Record<string, any>) {
  try {
    const analytics = await getAnalyticsSafe();
    if (!analytics) return;
    // Filter out undefined/null values to avoid noisy params
    const cleaned: Record<string, any> = {};
    if (params) {
      Object.keys(params).forEach((k) => {
        const v = (params as any)[k];
        if (v !== undefined && v !== null) cleaned[k] = v;
      });
    }
    logEvent(analytics, eventName as any, cleaned);
  } catch {
    // no-op
  }
}
